import { FC } from 'react'
import {
  StyleAuthHeaderWrapper,
  StyleTag,
  StyleTitle,
  StyleSubTitle,
} from './style'
interface AuthHeaderProps {
  title?: string
  subTitle?: string
  tag?: string
}
const AuthHeader: FC<AuthHeaderProps> = ({ title, subTitle, tag }) => {
  return (
    <StyleAuthHeaderWrapper>
      <StyleTitle>
        {title} <StyleTag>{tag}</StyleTag>
      </StyleTitle>
      {!!subTitle && <StyleSubTitle>{subTitle}</StyleSubTitle>}
    </StyleAuthHeaderWrapper>
  )
}

export default AuthHeader
